import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const mobileDrawerBody = css`
  position: relative;
  background: transparent;

  & > *:not(:last-child) {
    margin-block-end: ${spacing(0.75)};
  }
`
